<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :inputs="inputs"
    :moduleEnabler="moduleEnabler"
    :is-form-fetched="isFormFetched"
    @save="save"
  >
    <template #scadaDataSource.input="data">
      <v-col cols="3">
        <data-input v-bind="data" v-model="selectedDataSourceProps.datasource" @change="clearColumns" />
      </v-col>
    </template>
    <template v-for="(column, idx) of columns" #[`${column}.input`]="data">
      <v-col cols="3" :key="idx">
        <data-input
          v-bind="data"
          v-model="selectedDataSourceProps.settings[column]"
          @change="selectedDataSourcePropsChanged = true"
        />
      </v-col>
    </template>
  </admin-wrapper>
</template>
<script>
import { call, get } from 'vuex-pathify';
import AdminWrapper from '@/components/AdminWrapper';
import DataInput from '@/components/DataInput';
export default {
  name: 'ScadaAdmin',
  components: {
    AdminWrapper,
    DataInput,
  },
  computed: {
    additionalModuleName: get('admin/additionalModules.SCADA.verbose_name'),
    dataSources: get('layers/metadata'),
    isModuleEnabled: get('admin/settingsValues@scada_module_enabled'),
    dataSourceSettingsName: get('admin/modulesMapping@scada.selected_datasource_name'),
    dataSource() {
      return this.dataSources[this.selectedDataSourceProps.datasource];
    },
    dataSourceAttributes() {
      const datasourceAttributes = this.dataSource?.attributes_schema.attributes || [];
      return datasourceAttributes;
    },
    dataSourcesArray() {
      return this.$_objectToArray(this.dataSources).filter(
        dataSource => dataSource.scope === 'core' && !dataSource.module
      );
    },
    inputs() {
      const inputs = [
        {
          name: 'scadaDataSource',
          translationPath: 'admin.scadaDataSource',
          rules: [v => !!v || v == '0' || 'rules.required'],
          dataType: {
            name: 'select',
          },
          align: 'start',
          items: this.dataSourcesArray,
          itemValue: 'name',
          itemText: 'verbose_name',
        },
      ];
      for (const column of this.columns) {
        inputs.push({
          name: column,
          translationPath: `admin.${column}`,
          rules: [v => !!v || v == '0' || 'rules.required'],
          align: 'start',
          dataType: {
            name: 'select',
          },
          items: this.dataSourceAttributes,
          itemText: 'verbose_name',
          itemValue: 'name',
          disabled: !this.dataSource,
        });
      }
      inputs.push({
        name: 'scada_module_measurements_refresh_interval',
        align: 'start',
        translationPath: 'admin.refreshInterval',
        subtitle: 'admin.setScadaRefreshInterval',
        rules: [v => v === 0 || Boolean(v) || 'rules.required'],
        allowNegative: false,
        minValue: 1,
        dataType: {
          name: 'integer',
        },
      });
      return inputs;
    },
    moduleEnabler() {
      return {
        name: 'scada_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
  data: () => ({
    columns: ['system_type_column', 'measurement_id_column'],
    isFormFetched: false,
    selectedDataSourceProps: {
      settings: {
        system_type_column: '',
        measurement_id_column: '',
      },
      datasource: '',
    },
    selectedDataSourcePropsChanged: false,
  }),
  methods: {
    editDatasourceSettings: call('datasourceSettings/editDatasourceSettings'),
    getDatasourceSettings: call('datasourceSettings/getDatasourceSettings'),
    getDataSources: call('layers/getLayersMetadata'),
    getModulesMapping: call('admin/getModulesMapping'),
    clearColumns() {
      this.selectedDataSourceProps.settings.system_type_column = '';
      this.selectedDataSourceProps.settings.measurement_id_column = '';
      this.selectedDataSourcePropsChanged = true;
    },
    async init() {
      await Promise.all([this.getModulesMapping(), this.getDataSources({ with_attributes_schema: true })]);
      if (this.isModuleEnabled) {
        await this.updateSelectedDataSource();
      }
      this.isFormFetched = true;
    },
    async save() {
      if (!this.selectedDataSourcePropsChanged) {
        return;
      }
      const payload = { name: this.dataSourceSettingsName, settings: this.selectedDataSourceProps };
      try {
        await this.editDatasourceSettings(payload);
        this.selectedDataSourcePropsChanged = false;
      } catch {
        //
      }
    },
    async updateSelectedDataSource() {
      try {
        const r = await this.getDatasourceSettings(this.dataSourceSettingsName);
        const { datasource, settings } = r;
        this.selectedDataSourceProps = {
          datasource,
          settings,
        };
        this.selectedDataSourcePropsChanged = false;
      } catch {
        this.selectedDataSourceProps = {
          settings: {
            system_type_column: '',
            measurement_id_column: '',
          },
          datasource: '',
        };
        this.selectedDataSourcePropsChanged = false;
      }
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>
